/**
 * @file Whether a stored value is a `Date#toISOString()` string: it parses, and printing the parsed
 * instant gives back the same text. `parseAnalyticsReportDefinition` requires it of `nextRunAt`, and
 * `runDueReports` uses it to schedule a malformed definition's failed run at its stored instant. It
 * lives in `types/src` beside the parser, so the React report services read the same check.
 */
export const isIsoInstant = (value: unknown): value is string => typeof value === 'string' && !Number.isNaN(Date.parse(value)) && new Date(value).toISOString() === value;
